import { useAuthCtx } from '@/app/context/auth/authContextController/AuthContextController';
import { LoginPage } from '@/features/auth/login';
import { LoginMutationArguments } from '@/services/auth/auth.types';
import { createFileRoute, redirect } from '@tanstack/react-router';

const POST_LOGIN_ROUTE = '/' as const;

export const Route = createFileRoute('/(auth)/login')({
  beforeLoad: ({ context: { auth } }) => {
    const { accessToken } = auth;
    if (accessToken) {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: POST_LOGIN_ROUTE });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { login, isAuthenticating } = useAuthCtx();
  const handleLogin = (data: LoginMutationArguments) => {
    /*
     * Authentication enables the app-level permissions query. Do not navigate
     * here with the previous, empty router permission context. Once permissions
     * finish loading, this route's beforeLoad selects the correct destination.
     */
    login(data).catch(() => undefined);
  };

  return <LoginPage handleLogin={handleLogin} isAuthenticating={isAuthenticating} />;
}
